<template>
    <div class="main" v-if="culturalResource">
        <div class="header_margin">
            <span>
                <span class="site_label">Smithsonian Number</span>
                <span class="site_value">
                    <a v-on:click="goProduction" v-if="!isProduction">{{culturalResource.smithsonianNumber}}</a>
                    <span v-else>{{culturalResource.smithsonianNumber}}</span>
                </span>
            </span>
            <span>
                <span class="site_label">Site Name</span>
                <span class="site_value">{{ siteName }}</span>
            </span>
            <span>
                <span class="site_label">Time Period</span>
                <span class="site_value">{{ culturalResource.timePeriodDescription }}</span>
            </span>
        </div>
        <div v-if="currentEval">
            <div>
                <span class="site_label">Current Eligibility</span>
                <template v-if="!isListedLandmarkMonument">
                    <span class="site_value">{{ currentEval.eligibilityDescription || 'N/A' }}</span>
                    <template v-if="currentEval.eligibilityId === 1">
                        <span v-if="currentEval.isKeeperDetermined" class="site_value" style="color: red;">
                            Eligible By NRHP Keeper
                        </span>
                    </template>
                </template>
                <template v-else>
                    <span class="site_value" v-if="culturalResource.isListed">Listed</span>
                    <span class="site_value" v-if="culturalResource.isLandmark">Landmark</span>
                    <span class="site_value" v-if="culturalResource.isMonument">Monument</span>
                </template>
                <template>
                    <span class="site_label">Concurred</span>
                    <span class="site_value">{{ currentEval.concurredDescription || "N/A" }}</span>
                </template>
            </div>
            <div v-if="currentEval.eligibilityId === 1 && !isListedLandmarkMonument">
                <span class="site_label">Citeria</span>
                <span class="site_value">{{ criteriaList.join(', ') }}</span>
                <template v-if="currentEval.isEligibleB">
                    <span class="site_label">Associated Person</span>
                    <span class="site_value">{{ currentEval.associatedPerson }}</span>
                </template>
                <span class="site_label">Effect</span>
                <span class="site_value">{{ currentEval.effectDescription }}</span>
            </div>
            <div v-if="isSegment">
                <span class="site_label">Contributing Status</span>
                <span class="site_value">{{ contributingStatus }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'siteHeader',
    props: {
        culturalResource: {},
        siteName: {},
        currentEval: { default: null },
        isProduction: { default: false }
    },
    data: function () {
        return {
            isDebug: false
        }
    },
    computed: {
        criteriaList: function () {
            var list = []
            if (this.currentEval) {
                if (this.currentEval.isEligibleA) list.push('A')
                if (this.currentEval.isEligibleB) list.push('B')
                if (this.currentEval.isEligibleC) list.push('C')
                if (this.currentEval.isEligibleD) list.push('D')
            }
            return list
        },
        isListedLandmarkMonument: function () {
            return this.culturalResource.isListed || this.culturalResource.isLandmark || this.culturalResource.isMonument
        },
        isSegment: function () {
            return this.culturalResource && this.culturalResource.segment > 0
        },
        contributingStatus: function () {
            if (this.currentEval.isContributing === true) return 'Contributing'
            else if (this.currentEval.isContributing === false) return 'Not contributing'
            else return 'Unevaluated'
        }
    },
    created () {
        loggingService.log(this.isDebug, 'siteHeader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'siteHeader', 'mounted')
    },
    methods: {
        goProduction () {
            let routeData = this.$router.resolve({name: 'CulturalResource', params: {culturalResourceId: this.culturalResource.culturalResourceId}})
            window.open(routeData.href, '_blank')
        }
    }
}
</script>

<style>
    .main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .site_label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
    }
    .site_value {
        margin-right: 20px;
        font-weight: bold;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// SiteHeader.vue?3dd66e05